const routes = {
  shifts: 'שעות בית ספר',
  passengers: 'תלמידים'
};

export default routes;
